import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@supoui/core/services/http.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false
})
@UntilDestroy({ checkProperties: true })
export class FooterComponent implements OnInit {
  onesosuiSettings: any;
  onesosuaaSettings: any;
  onesosGuidelineSettings: any;
  supoInvoiceSettings: any;
  caseManagementSettings: any;
  caseEconomyServiceSettings: any;
  onePointSettings: any;
  documentServiceSettings: any;

  show = false;
  shown = false;

  constructor(private httpService: HttpService, private logger: NGXLogger) {}

  ngOnInit(): void {
    this.getOnesosuiSettings().subscribe(onesosuiSettings => (this.onesosuiSettings = onesosuiSettings));
    this.getOnesosuaaSettings().subscribe(onesosuaaSettings => (this.onesosuaaSettings = onesosuaaSettings));
    this.getSupoInvoiceSettings().subscribe(supoInvoiceSettings => (this.supoInvoiceSettings = supoInvoiceSettings));
    this.getCaseManagementSettings()
      .subscribe(caseManagementSettings => (this.caseManagementSettings = caseManagementSettings));
    this.getCaseEconomyServiceSettings()
      .subscribe(caseEconomyServiceSettings => (this.caseEconomyServiceSettings = caseEconomyServiceSettings));
    this.getOnePointSettings().subscribe(onePointSettings => (this.onePointSettings = onePointSettings));
    this.getDocumentServiceSettings()
      .subscribe(documentServiceSettings => (this.documentServiceSettings = documentServiceSettings));
    this.getSupoinvoiceServiceSettings().subscribe(supoInvoiceSettings => (this.supoInvoiceSettings = supoInvoiceSettings));
  }

  get footerStyle(): any {
    if (!this.shown) {
      return { left: '49%', right: 'inherit', height: '20px', top: 'calc(100vh - 20px)' };
    } else {
      return { left: '49%', right: 'inherit', height: '20px', top: 'calc(100vh - 63px)' };
    }
  }

  toggle(): void {
    this.shown = !this.shown;
  }

  getOnesosuiSettings(): Observable<any> {
    return this.httpService.get<any>('services/supo-ui/');
  }

  getOnesosuaaSettings(): Observable<any> {
    return this.httpService.get<any>('services/supo-user-administration/');
  }

  getOnesosGuidelineSettings(): Observable<any> {
    return this.httpService.get<any>('services/onesosguideline/');
  }

  getSupoInvoiceSettings(): Observable<any> {
    return this.httpService.get<any>('services/supo-invoice/');
  }

  getCaseManagementSettings(): Observable<any> {
    return this.httpService.get<any>('services/casemanagement/');
  }

  getOnePointSettings(): Observable<any> {
    return this.httpService.get<any>('services/onepoint/');
  }

  getCaseEconomyServiceSettings(): Observable<any> {
    return this.httpService.get<any>('services/caseeconomy/');
  }

  getDocumentServiceSettings(): Observable<any> {
    return this.httpService.get<any>('services/documentservice/');
  }

  getSupoinvoiceServiceSettings(): Observable<any> {
    return this.httpService.get<any>('services/supo-invoice/');
  }
}
